/** The Leaflet build loaded as a classic script by index.html (the shared
 *  viewer's vendored copy). Typed structurally with only what the web app's
 *  own components call, so tests can install a small fake. */

export interface LPoint {
  x: number;
  y: number;
}

export interface LMap {
  /** Present unless the map was built with `attributionControl: false`. */
  attributionControl?: {
    addAttribution(text: string): unknown;
    removeAttribution(text?: string): unknown;
  };
  fitBounds(bounds: [[number, number], [number, number]], options?: object): void;
  invalidateSize(): void;
  remove(): void;
  scrollWheelZoom: { enable(): void; disable(): void };
  on(event: string, handler: () => void): this;
  off(event: string, handler: () => void): this;
  latLngToContainerPoint(latlng: [number, number]): LPoint;
  containerPointToLatLng(point: LPoint): [number, number] | { lat: number; lng: number };
}

export interface LLayer {
  addTo(map: LMap): this;
  remove(): void;
  on(event: string, handler: () => void): this;
}

export interface LTileLayer extends LLayer {
  /** Repoint the layer at another template and redraw (the tile guard's swap). */
  setUrl(url: string): this;
}

export interface LPolyline extends LLayer {
  setStyle(style: object): this;
  bringToFront(): this;
  bindTooltip(text: string, options?: object): this;
}

export interface LMarker extends LLayer {
  setLatLng(latlng: [number, number]): this;
}

export interface LeafletGlobal {
  map(el: HTMLElement, options: object): LMap;
  tileLayer(url: string, options: object): LTileLayer;
  polyline(latlngs: [number, number][], options: object): LPolyline;
  marker(latlng: [number, number], options: object): LMarker;
  divIcon(options: object): unknown;
}

export function leafletGlobal(): LeafletGlobal | null {
  return (globalThis as { L?: LeafletGlobal }).L ?? null;
}
